import * as React from "react";

const fields = (categoryId, machineModelId, t) => {
    return {
        config: {columns: 1},
        fields: [
            {
                name: "id",
                label: "id",
                mandatory: true,
                column: 1,
                type: "unvisible"
            },
            {
                name: "name",
                label: t ? t("common.name") : "Nazwa",
                column: 1,
                mandatory: true,
                hideForReadOnly: true
            }, {
                name: "contactWithProduct",
                label: t ? t("common.contact_with_product") : "Kontakt z produktem",
                defaultEnabled: true,
                type: "boolean",
                column: 1,
            }, {
                name: "installationNumber",
                label: t ? t("common.installation_number") : "Numer instalacyjny",
                column: 1,
            },
            {
                name: "comment",
                label: t ? t("common.comments") : "Uwagi",
                column: 1,
            },
            {
                name: "files",
                label: t ? t("common.photos") : "Zdjęcia",
                column: 1,
                type: "file"
            },
            {
                name: "ignore",
                label: t ? t("common.ignore") : "Ignoruj przy produkcji",
                defaultValue: "false",
                type: "boolean",
                column: 1,
            },
            {
                name: "categoryId",
                label: "categoryId",
                mandatory: true,
                column: 1,
                type: "unvisible",
                defaultValue: categoryId
            },
            {
                name: "machineModelId",
                label: "machineModelId",
                mandatory: true,
                column: 1,
                type: "unvisible",
                defaultValue: machineModelId
            }
        ]

    }
};

export default fields;